import React, { Component } from "react"
import FlatList from "flatlist-react"
import "./AirportList.css"
import { Forms } from "../../styleguide/js/components/forms"
import { isMobile } from "react-device-detect"
import AirportAccordion from "./airport-accordion"

class AirportList extends Component {
  static defaultProps = {
    airports: [],
    searchMinCharactersCount: 2,
  }
  constructor(props) {
    super(props)
    this.containerRef = React.createRef()
  }
  state = {
    countryList: [],
    letterIndex: [],
    countryCityList: [],
    query: "",
  }

  componentDidMount() {
    const letterIndex = [...new Set(this.props.airports.map((a) => a.countryName.substr(0, 1)))].sort()
    let countryCityList = this.props.airports.map((c) => {
      c.allText = ""
      c.letterIndex = c.countryName.substr(0, 1)
      c.airports.forEach((a) => {
        c.allText += `${[a.city, a.iataCode, a.countryName, a.city].join(" ")} `
      })
      c.city = "temp console fix"

      return c
    })
    this.setState({ letterIndex, countryCityList })
    new Forms({ el: this.containerRef.current })
  }

  renderAirport = (airport, idx) => {
    return (
      <li key={idx}>
        <a className="button button--link button--link--heavy has-icon" href={airport.shortUrl}>
          <span className="icon">
            <svg className="svg-icon svg-icon--arrowright">
              <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-arrowright">
                &nbsp;
              </use>
            </svg>
          </span>

          <span className="text">
            {airport.text} (<span>{airport.iataCode}</span>){" "}
          </span>
        </a>
      </li>
    )
  }

  renderCountryAndCity = (cities) => {
    const { query } = this.state
    const isActive = query && query.length >= this.props.searchMinCharactersCount
    const country = cities && cities.countryName

    const countryAirports = cities && cities.airports

    return (
      <div style={{ marginBottom: "20px", width: "100%", display: "block" }}>
        <AirportAccordion label={country} className={"country-group-separator"} key={country} isActive={isActive}>
          <div className="article__box">
            {/* <ul style={{display:"none"}}> */}
            <ul style={{ display: "block" }}>
              <FlatList
                list={countryAirports}
                renderItem={this.renderAirport || `${() => <div></div>}`}
                renderWhenEmpty={() => <div>{this.props.textKeys.listNoSearchResultsLabel || "Ingen matchende resultater"}</div>}
                sortBy={["countryName", "city"]}
                groupBy={(airport) => [airport.city]}
                groupSeparator={this.citySeparator}
                groupSortedBy={["city"]}
                searchBy={["iataCode", "text", "city", "countryName"]}
                searchTerm={this.state.query}
                searchCaseInsensitive
                searchMinCharactersCount={this.props.searchMinCharactersCount}
              />
            </ul>
          </div>
        </AirportAccordion>
      </div>
    )
  }

  scrollToId = (id) => {
    // element which needs to be scrolled to
    var element = document.querySelector(id)

    // scroll to element
    element.scrollIntoView({ behavior: "smooth", block: "center" })
  }

  renderIndex = (letters) => {
    return (
      <div id="verticalIndexContainer" className={`${isMobile ? "is-mobile" : ""}`}>
        <div id="verticalIndex" className={`${isMobile ? "is-mobile" : ""}`}>
          <ul>
            {letters.map((l) => {
              const scrollTarget = "#first_letter_" + l
              return (
                <li key={l}>
                  <button onClick={() => this.scrollToId(scrollTarget)}>{l}</button>
                </li>
              )
            })}
          </ul>
        </div>
      </div>
    )
  }

  letterSeparator = (group, idx, groupLabel) => {
    return (
      <div className="letter-group-label" style={{ marginBottom: "20px", width: "100%", display: "block" }}>
        {groupLabel}
      </div>
    )
  }

  renderSearch = (query) => {
    return (
      <div className="form">
        <div className="form__section">
          <div className="form__section__inner">
            <div className="form__field form__field--text form__field--text-search form__field--text--no-label">
              <span className="form__valid" />
              <input
                className="form__item"
                value={query}
                onChange={(e) => this.setState({ query: e.target.value })}
                type="text"
                placeholder={this.props.textKeys.listSearchPlaceholderLabel || "Søg... "}
              />

              <button onClick={(e) => this.setState({ query: e.target.value })}>
                <span className="icon">
                  <svg className="svg-icon svg-icon--search">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/dist/svg/symbols.svg#svg-search">
                      &nbsp;
                    </use>
                  </svg>
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  }

  citySeparator = (group, idx, groupLabel) => (
    <div style={{ marginBottom: "20px", width: "100%", display: "block" }}>
      <h4 className="group-separator">{groupLabel}</h4>
    </div>
  )

  render() {
    const { query, countryCityList, letterIndex } = this.state
    return (
      <div className="destination-list" ref={this.containerRef}>
        {this.renderSearch(query)}
        {this.renderIndex(letterIndex)}
        <div className={`destination-list__container is-county-list ${isMobile ? "is-mobile" : ""}`}>
          <FlatList
            list={countryCityList}
            renderItem={this.renderCountryAndCity || `${() => <div></div>}`}
            renderWhenEmpty={() => <div>{this.props.textKeys.listNoSearchResultsLabel || "Ingen matchende resultater"}</div>}
            sortBy={["letterIndex", "countryName", "city"]}
            groupBy={"letterIndex"}
            groupSeparator={this.letterSeparator}
            groupSortedBy={["letterIndex"]}
            searchBy={["allText"]}
            searchTerm={query}
            searchCaseInsensitive
            searchMinCharactersCount={this.props.searchMinCharactersCount}
          />
        </div>
      </div>
    )
  }
}
export default AirportList
